export const triggerProjectsInteractionAnalytics = (payload) => {
  LIFE_CYCLE_EVENT_BUS.trigger('projects.interaction', payload);
};

export const handleProjectCreationFromNullState = ({ newProject, hasProjects, componentId }) => {

  if (!hasProjects) {
    const projectCreationPayload = {
      action: 'button-click',
      component: 'null state create project',
      id: componentId,
    };
    // Trigger analytics event when project is successfully created
    if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
      window.LIFE_CYCLE_EVENT_BUS.trigger('projects.interaction', projectCreationPayload);
    }
  }

  const id = newProject?.id;
  if (id) {
    window.location.href = `/projects/${id}`;
  }
};
